import Api from "./Api"
import PublicApi from "./PublicApi"

export default {
    login(credenciales){
        return PublicApi().post("/v1/auth/login", credenciales);
    },
    registro: function(datos){
        return PublicApi().post("/v1/auth/register", datos);
    },
    perfil: () => {
        return Api().get("/v1/auth/profile");
    },
    logout: () => {
        return Api().post("/v1/auth/logout");
    },
    recuperarPassword: (datos) => {
        return PublicApi().post("/reset-password", datos);
    },
    resetPassword: (datos) => {
        return PublicApi().post("/cambio-password", datos);
    },
    loginConGoogleURL: () => {
        return PublicApi().get(`/google-auth/redirect`);
    },
    /*loginConGoogle: (datos) => {
        return Api().post(`/google-auth/callback?code=${datos.code}&scope=${datos.scope}&authuser=${datos.authuser}&prompt=${datos.prompt}`)
    }*/
}
